module.exports = __webpack_public_path__ + "img/8.ff4490e2.jpg";